import { render } from "./close-button.vue?vue&type=template&id=7bc7547f&scoped=true"
import script from "./close-button.vue?vue&type=script&lang=js"
export * from "./close-button.vue?vue&type=script&lang=js"

import "./close-button.vue?vue&type=style&index=0&id=7bc7547f&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc7547f"]])

export default __exports__